import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import marked from 'marked';
import get from 'utils/get';
import flattenMediaData from 'utils/flattenMediaData';
import laureateModel from 'models/laureateModel';
import { Colors } from 'constants/Variables';

import { Button, Image } from 'components/base';

const LaureateStoryFooter = ({ relatedLaureates, contentColor }) => {
  const arrowImage =
    contentColor === Colors.DARK_GRAY
      ? `${process.env.PUBLIC_URL}/assets/images/icon-right-arrow-dark.svg`
      : `${process.env.PUBLIC_URL}/assets/images/icon-right-arrow.svg`;

  return (
    <div className="LaureateStoryFooter flex items-center justify-center pt4 pb8">
      <div className="LaureateStoryFooter__container w100 flex flex-col justify-center lg:flex-row lg:items-center">
        <div className="flex flex-col lg:flex-row lg:flex-wrap lg:items-center">
          <p className="LaureateStoryFooter__info-text nowrap mx2 lg:mx0 px1 lg:px0 lg:col-4">
            Read these next:
          </p>
          <div className="LaureateStoryFooter__laureate-container flex items-end justify-start col-12 lg:col-8 pr2">
            {relatedLaureates.map((laureate, i) => {
              const fields = get(laureate, 'fields', {});
              const firstName = get(fields, 'firstName', '');
              const middleName = get(fields, 'middleName', '');
              const lastName = get(fields, 'lastName', '');
              const awards = get(fields, 'awards', '');
              const image = flattenMediaData(get(fields, 'image', {}));
              const link = get(fields, 'link', '');

              return (
                <Button
                  color={contentColor}
                  ariaLabel={`read ${firstName} ${middleName} ${lastName}'s story`}
                  key={get(laureate, 'sys.id', i)}
                  to={`/stories/${link}`}
                >
                  <div
                    className={cx('flex flex-col mx1 ', {
                      'pl1 lg:pl0': !i
                    })}
                  >
                    <div
                      className="LaureateStoryFooter__award mt1 mx1"
                      dangerouslySetInnerHTML={{
                        __html: marked(awards)
                      }}
                    />
                    <Image
                      className="LaureateStoryFooter__laureate-image m1 fit-contain flex items-center justify-center"
                      src={get(image, 'url', '')}
                      alt={get(image, 'description', '')}
                    />
                    <p className="LaureateStoryFooter__name color-gold-brown uppercase nowrap m1 flex flex-col">
                      {!!firstName && <span>{firstName}</span>}
                      {!!middleName && <span>{middleName}</span>}
                      {!!lastName && <span>{lastName}</span>}
                    </p>
                  </div>
                </Button>
              );
            })}
          </div>
        </div>
        <div className="LaureateStoryFooter__line none lg:block mx4" />
        <div className="LaureateStoryFooter__explore-connections mr3_5 ml2 px1 lg:px0 lg:ml0 ">
          <Button
            color={contentColor}
            to="/explore"
            ariaLabel="go to explore page"
          >
            <div className="flex items-center">
              <span className="LaureateStoryFooter__info-text LaureateStoryFooter__button w100">
                Explore Laureate Connections
              </span>
              <Image
                className="small-icon-width"
                src={arrowImage}
                alt="go to explore page"
              />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

LaureateStoryFooter.propTypes = {
  relatedLaureates: PropTypes.arrayOf(laureateModel.propTypes),
  contentColor: PropTypes.string
};

LaureateStoryFooter.defaultProps = {
  relatedLaureates: [],
  contentColor: 'Dark Gray'
};

export default LaureateStoryFooter;
